interface Idea {
  id: number;
  title: string;
  daysToWarn: number;
  daysToAlert: number;
  url?: string;
  lastDate?: Date;
}

const ideas: Idea[] = [
  // {
  //   id: 1,
  //   title: 'Мои проблемы',
  //   daysToWarn: 4,
  //   daysToAlert: 7,
  // },
  // {
  //   id: 2,
  //   title: 'Проблемы знакомых',
  //   daysToWarn: 30,
  //   daysToAlert: 90,
  // },
  {
    id: 3,
    title: 'Полить цветы',
    daysToWarn: 6,
    daysToAlert: 8,
  },
  // {
  //   id: 4,
  //   title: 'Залить воду в пылесос',
  //   daysToWarn: 7,
  //   daysToAlert: 14,
  // },
  // {
  //   id: 5,
  //   title: 'Документы',
  //   daysToWarn: 30,
  //   daysToAlert: 60,
  // },
  // {
  //   id: 6,
  //   title: 'Фотографии с телефона',
  //   daysToWarn: 7,
  //   daysToAlert: 14,
  // },
  // {
  //   id: 7,
  //   title: 'Разобрать заметки',
  //   daysToWarn: 7,
  //   daysToAlert: 14,
  // },
  {
    id: 8,
    title: 'Уборка',
    daysToWarn: 3,
    daysToAlert: 7,
  },
  {
    id: 9,
    title: 'Чистка разума',
    daysToWarn: 7,
    daysToAlert: 14,
    url: 'https://github.com/polyakovin/articles/blob/master/personal-performance/gtd_checklist.md',
  },
  // {
  //   id: 10,
  //   title: 'Переупаковать старую публикацию',
  //   daysToWarn: 2,
  //   daysToAlert: 4,
  // },
  // {
  //   id: 11,
  //   title: 'Путешествия',
  //   daysToWarn: 90,
  //   daysToAlert: 180,
  // },
  // {
  //   id: 12,
  //   title: 'Идеи проектов',
  //   daysToWarn: 60,
  //   daysToAlert: 120,
  // },
  {
    id: 13,
    title: 'Личная почта',
    daysToWarn: 3,
    daysToAlert: 7,
  },
  {
    id: 14,
    title: 'Рабочая почта',
    daysToWarn: 1,
    daysToAlert: 2,
  },
  // {
  //   id: 15,
  //   title: 'Важное дело Hints',
  //   url: 'https://miro.com/app/board/o9J_lvrgKaU=/',
  //   daysToWarn: 1,
  //   daysToAlert: 2,
  // },
  // {
  //   id: 16,
  //   title: 'Публикации',
  //   daysToWarn: 30,
  //   daysToAlert: 60,
  // },
  // {
  //   id: 17,
  //   title: 'GoPractice',
  //   url: 'https://gopractice.ru/course/pm/front/task/593959',
  //   daysToWarn: .5,
  //   daysToAlert: 1,
  // },
  // {
  //   id: 18,
  //   title: 'Образование',
  //   daysToWarn: 14,
  //   daysToAlert: 30,
  // },
  // {
  //   id: 19,
  //   title: 'Репозитории',
  //   daysToWarn: 180,
  //   daysToAlert: 360,
  // },
  // {
  //   id: 20,
  //   title: 'Папка «Загрузки»',
  //   daysToWarn: 7,
  //   daysToAlert: 30,
  // },
  // {
  //   id: 21,
  //   title: 'Рабочий стол',
  //   daysToWarn: 7,
  //   daysToAlert: 14,
  // },
  {
    id: 22,
    title: 'Погулять на улице',
    daysToWarn: 1,
    daysToAlert: 2,
  },
  // {
  //   id: 23,
  //   title: 'Важное дело в Росбанке',
  //   url: 'https://kb.rosbank.rus.socgen/pages/viewpage.action?pageId=461480947',
  //   daysToWarn: 1,
  //   daysToAlert: 2,
  // },
  // {
  //   id: 24,
  //   title: 'Игры',
  //   daysToWarn: 180,
  //   daysToAlert: 360,
  // },
  // {
  //   id: 25,
  //   title: 'Фильмы',
  //   daysToWarn: 60,
  //   daysToAlert: 180,
  // },
  // {
  //   id: 26,
  //   title: 'Новости',
  //   daysToWarn: 7,
  //   daysToAlert: 14,
  // },
  // {
  //   id: 27,
  //   title: 'Соцсети',
  //   daysToWarn: 30,
  //   daysToAlert: 90,
  // },
  {
    id: 28,
    title: 'Бег',
    daysToWarn: 1,
    daysToAlert: 2,
  },
  // {
  //   id: 29,
  //   title: 'Важное дело «Попробуй всё»',
  //   url: 'https://trello.com/b/XOXhlOq1/попробуй-всё',
  //   daysToWarn: 3,
  //   daysToAlert: 6,
  // },
  // {
  //   id: 30,
  //   title: 'Попробуй всё. Тест активности',
  //   url: 'https://polyakovin.github.io/want-smth-test/',
  //   daysToWarn: 1,
  //   daysToAlert: 2,
  // },
  // {
  //   id: 31,
  //   title: 'Новая публикация',
  //   daysToWarn: 2,
  //   daysToAlert: 4,
  // },
  {
    id: 32,
    title: 'Важное дело для себя',
    daysToWarn: 1,
    daysToAlert: 2,
  },
  {
    id: 33,
    title: 'Витамины',
    daysToWarn: 1,
    daysToAlert: 2,
  },
  // {
  //   id: 34,
  //   title: 'Взвеситься',
  //   url: 'https://docs.google.com/spreadsheets/d/199QmLrSiEgPzWBUfFBrpb3-ixLBIq1Bmi7xoSw84h1g/edit#gid=0',
  //   daysToWarn: 7,
  //   daysToAlert: 8,
  // },
  {
    id: 35,
    title: 'Обязательные дела на день',
    url: 'https://polyakovin.github.io/daily-organizer/',
    daysToWarn: .5,
    daysToAlert: 1,
  },
  {
    id: 36,
    title: 'Постричься',
    daysToWarn: 60,
    daysToAlert: 80,
  },
  // {
  //   id: 37,
  //   title: 'Побриться',
  //   daysToWarn: 3,
  //   daysToAlert: 4,
  // },
  {
    id: 38,
    title: 'Профилактика зубов',
    daysToWarn: 180,
    daysToAlert: 200,
  },
  // {
  //   id: 39,
  //   title: 'Профилактика глаз',
  //   daysToWarn: 180,
  //   daysToAlert: 200,
  // },
  {
    id: 40,
    title: 'Постричь ногти',
    daysToWarn: 180,
    daysToAlert: 200,
  },
  {
    id: 41,
    title: 'Выпить воды',
    daysToWarn: 1/48,
    daysToAlert: 1/24,
  },
  {
    id: 42,
    title: 'Зарядка',
    daysToWarn: .5,
    daysToAlert: 1,
  },
  {
    id: 43,
    title: 'Курс массажа',
    daysToWarn: 90,
    daysToAlert: 120,
  },
  // {
  //   id: 44,
  //   title: 'Замер параметров тела',
  //   url: 'https://docs.google.com/spreadsheets/d/1xFOFQ3SDrlLpaDyR8aUsD-7kDus50b6WFfyr2UupGvU/edit#gid=0',
  //   daysToWarn: 6,
  //   daysToAlert: 8,
  // },
  // {
  //   id: 45,
  //   title: 'Выбор нового навыка',
  //   daysToWarn: 6,
  //   daysToAlert: 8,
  // },
  // {
  //   id: 46,
  //   title: 'Освоение нового навыка',
  //   daysToWarn: .5,
  //   daysToAlert: 1,
  // },
  // {
  //   id: 47,
  //   title: 'Оплатить квартиру',
  //   daysToWarn: 20,
  //   daysToAlert: 30,
  // },
  // {
  //   id: 48,
  //   title: 'Побрить там',
  //   daysToWarn: 7,
  //   daysToAlert: 10,
  // },
  // {
  //   id: 49,
  //   title: 'Ревью целей',
  //   daysToWarn: 12,
  //   daysToAlert: 15,
  // },
  // {
  //   id: 50,
  //   title: 'Ревью идей проектов',
  //   daysToWarn: 20,
  //   daysToAlert: 30,
  // },
  {
    id: 51,
    title: 'Заняться чем-то новым',
    daysToWarn: 5,
    daysToAlert: 7,
  },
  // {
  //   id: 52,
  //   title: 'Пофантазировать над комбо-целями',
  //   daysToWarn: 5,
  //   daysToAlert: 7,
  // },
  // {
  //   id: 53,
  //   title: 'Вести дневник, обращая внимание на неудачи',
  //   daysToWarn: 1,
  //   daysToAlert: 2,
  // },
  {
    id: 54,
    title: 'Упражнения для позвоночника',
    url: 'https://www.youtube.com/watch?v=toDNwxQTSzI',
    daysToWarn: 1,
    daysToAlert: 2,
  },
];

export default ideas;
